import React from "react";
import Android from "@material-ui/icons/Android";
import Apps from "@material-ui/icons/Apps";
import ArrowRightAlt from "@material-ui/icons/ArrowRightAlt";
import CallMade from "@material-ui/icons/CallMade";
import CallReceived from "@material-ui/icons/CallReceived";
import ChatBubbleOutline from "@material-ui/icons/ChatBubbleOutline";
import Check from "@material-ui/icons/Check";
import Close from "@material-ui/icons/Close";
import ExpandLess from "@material-ui/icons/ExpandLess";
import ExpandMore from "@material-ui/icons/ExpandMore";
import FilterList from "@material-ui/icons/FilterList";
import Gavel from "@material-ui/icons/Gavel";
import HighlightOff from "@material-ui/icons/HighlightOff";
import InfoOutlined from "@material-ui/icons/InfoOutlined";
import MonetizationOn from "@material-ui/icons/MonetizationOn";
import MoveToInbox from "@material-ui/icons/MoveToInbox";
import ImageOutlined from "@material-ui/icons/ImageOutlined";
import OpenInNew from "@material-ui/icons/OpenInNew";
import PeopleOutline from "@material-ui/icons/PeopleOutline";
import PlayCircleFilled from "@material-ui/icons/PlayCircleFilled";
import Refresh from "@material-ui/icons/Refresh";
import Search from "@material-ui/icons/Search";
import Send from "@material-ui/icons/Send";
import Star from "@material-ui/icons/Star";
import TrendingDown from "@material-ui/icons/TrendingDown";
import TrendingUp from "@material-ui/icons/TrendingUp";
import ViewList from "@material-ui/icons/ViewList";
import Warning from "@material-ui/icons/Warning";

// Maps the lucide-style name strings the pages already use onto
// @material-ui/icons equivalents.
const ICONS = {
  "layout-grid": Apps,
  bot: Android,
  scale: Gavel,
  "arrow-up-right": CallMade,
  "arrow-down-right": CallReceived,
  "arrow-right": ArrowRightAlt,
  info: InfoOutlined,
  "triangle-alert": Warning,
  "search-x": MoveToInbox,
  send: Send,
  "chevron-up": ExpandLess,
  "chevron-down": ExpandMore,
  "external-link": OpenInNew,
  check: Check,
  "x-circle": HighlightOff,
  "trending-up": TrendingUp,
  "trending-down": TrendingDown,
  x: Close,
  search: Search,
  filter: FilterList,
  "refresh-cw": Refresh,
  "message-circle": ChatBubbleOutline,
  "dollar-sign": MonetizationOn,
  star: Star,
  list: ViewList,
  video: PlayCircleFilled,
  image: ImageOutlined,
  users: PeopleOutline,
};

export default function Icon({ name, size = 16, style, ...rest }) {
  const Component = ICONS[name];
  if (!Component) return null;
  return <Component style={{ fontSize: size, flexShrink: 0, ...style }} {...rest} />;
}
